<template>
  <b-container class="live-now" fluid>
    <b-row class="flex-column-reverse flex-md-row">
      <b-col md="8">
        <b-row>
          <b-col>
            <p class="text-white title">{{ liveStream.title }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="text-white sub-title">{{ liveStream.subtitle }}</p>
          </b-col>
        </b-row>


        <b-row v-if="liveStream.livenow">
          <b-col
            class="buttons-container d-flex justify-content-center justify-content-md-start"
          >
            <a
              href="https://zoom.us/webinar/register/WN_amII22BgS2C0_NlExIbqFw"
            >
              <b-button class="button-white">Watch Now</b-button>
            </a>
          </b-col>
        </b-row>
        <span v-else>
        <b-row>
          <b-col>
            <span>
              <p class="text-white sub-title">{{ liveStream.datePretty }} 10:30 am PST</p>
            </span>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            class="buttons-container d-flex justify-content-center justify-content-md-start"
          >
            <span
             v-if="liveStream.eventBrite != ''"
            >
              <a
              :href="liveStream.eventBrite"
              >
                <b-button class="calendar-button">
                  <b-icon icon="calendar" class="mr-2"></b-icon>Add to Calendar
                </b-button>
              </a>

            </span>
            <span
             v-else
            >
              <a
              href="https://zoom.us/webinar/register/WN_amII22BgS2C0_NlExIbqFw"
              >
                <b-button class="calendar-button">
                  <b-icon icon="calendar" class="mr-2"></b-icon>Add to Calendar
                </b-button>
              </a>

            </span>


          </b-col>
        </b-row>
        </span>
      </b-col>



      <b-col md="4" class="author">
        <b-row align-h="end" class="mb-2">
          <a :href="liveStream.linkedinURL" target="_blank">
            <b-col class="avatar">
              <b-avatar
                class="avatar-image"
                :src="require('../assets/guests/' + liveStream.photoFileName)"
              ></b-avatar>
            </b-col>
          </a>
        </b-row>
        <b-row>
          <b-col>
            <p class="text-white name">{{ liveStream.name }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="text-white position-company">{{ liveStream.position }}</p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/_components/main-card.sass
</style>

<script>
export default {
  name: 'MainCard',
  props: ['liveStream'],
}
</script>
